import { useContext } from "react";
import * as forgerock from "@forgerock/javascript-sdk";
import { MyContext } from "@/context.js";
import { getOuthClient } from "@/utils/arkleConfig";
import { getLocationParamer } from "@/utils/common";
import { updatePasswordReg } from "@/utils/reg";
import { TrackClickEvent } from "@/utils/adobeLaunch";
import { useWcipNavigate } from "@/hooks";
const errorCodeRange = (num) => {
    return num >= 400 && num <= 599 && num !== 401;
};

const appType = getLocationParamer("appType");
const showSystemErrorCodeList = [
    "ERR006",
    "ERR014",
    "ERR050",
    "ERR065",
    "ERR0111",
    "ERR048",
];
const updatePasswordErrorHandleFunc = (withLangNavigate) => {
    const pathName = location.pathname;
    if (updatePasswordReg?.wcipChange.test(pathName)) {
        withLangNavigate("/update-error");
    }

    if (updatePasswordReg?.wcipForgot.test(pathName)) {
        withLangNavigate("/update-error", "?forgot=true");
    }

    if (updatePasswordReg?.csspChange.test(pathName)) {
        withLangNavigate("/change/cssp/update-error");
    }

    if (updatePasswordReg?.csspForgot.test(pathName)) {
        withLangNavigate("/forgot/cssp/update-error");
    }

    if (updatePasswordReg?.csspAssociate.test(pathName)) {
        withLangNavigate("/associate/cssp/update-error");
    }

    if (updatePasswordReg?.mobileAppChange.test(pathName)) {
        withLangNavigate("/change/mobileApp/notification", "?status=fail");
    }

    if (updatePasswordReg?.mobileAppForgot.test(pathName)) {
        withLangNavigate("/forgot/mobileApp/notification", "?status=fail");
    }

    if (updatePasswordReg?.memberChange.test(pathName)) {
        TrackClickEvent(
            `btn_wcip-MB_ChangeS3InputPwd_fail_NetworkError`,
            pathName.indexOf("en-us") > 0 ? "en-us" : "zh-hk"
        );
        withLangNavigate("/change/member/serviceIssues");
    }

    if (updatePasswordReg?.memberForgot.test(pathName)) {
        TrackClickEvent(
            `btn_wcip-MB_ForgetS2bInputID_fail_NetworkError`,
            pathName.indexOf("en-us") > 0 ? "en-us" : "zh-hk"
        );
        withLangNavigate("/forgot/member/serviceIssues");
    }

    if (updatePasswordReg?.wcipAssociate.test(pathName)) {
        withLangNavigate("/update-error", "?associate=true");
    }
    if (updatePasswordReg?.mobileAppAssociate.test(pathName)) {
        withLangNavigate("/associate/mobileApp/notification", "?status=fail");
    }
};
export const useArkleNextHook = () => {
    const { showErrorPopup } = useContext(MyContext);
    const { withLangNavigate } = useWcipNavigate();
    const next = async (step, isNeedToError) => {
        try {
            if (step != null) {
                window.sessionStorage.setItem("ArkleStage", step?.getStage());
            } else {
                window.sessionStorage.removeItem("ArkleStage");
            }

            const rsp = await forgerock.FRAuth.next(step);
            if (window.showException == true) {
                window.showException = false;
                throw new Error("test exception")();
            }
            if (rsp === undefined) {
                //cant get rsp
                throw new Error("NetworkError")();
            } else {
                if (errorCodeRange(rsp.payload.status)) {
                    if (appType) {
                        showErrorPopup(
                            "LB_BS_LOGIN_ERROR_CIAM_100103_APP",
                            appType,
                            "",
                            "LB_CLOSE"
                        );
                    } else {
                        throw new Error("Error in next")();
                    }
                }

                if (rsp.payload.code == 401) {
                    const buttonText = "LB_CLOSE";
                    // token expried
                    const erorType = appType
                        ? appType
                        : window.location.pathname.includes("member")
                        ? "member"
                        : window.location.pathname.includes("cssp")
                        ? "cssp"
                        : "wcip";
                    if (rsp?.payload?.detail) {
                        if (
                            rsp?.payload?.detail?.failureUrl === "ERR001" ||
                            rsp?.payload?.detail?.errorCode === "110"
                        ) {
                            const buttonText = "LB_CLOSE";
                            const pathname = window.location.pathname;
                            const errorCode =
                                rsp?.payload?.detail?.failureUrl ||
                                rsp?.payload?.detail?.errorCode;
                            if (updatePasswordReg?.wcipProfile.test(pathname)) {
                                showErrorPopup(
                                    {
                                        msg: "WCIP_PERFERENCE_001_FAILURE",
                                        code: errorCode,
                                    },
                                    "wcip",
                                    "",
                                    buttonText,
                                    "",
                                    () => {
                                        withLangNavigate("/login", "?LR=1");
                                    }
                                );
                            } else if (
                                updatePasswordReg?.memberChange?.test(pathname)
                            ) {
                                showErrorPopup(
                                    {
                                        msg: "WCIP_PERFERENCE_001_FAILURE",
                                        code: errorCode,
                                    },
                                    "member"
                                );
                                // setTimeout(() => {
                                //     withLangNavigate(
                                //         "/login/member",
                                //         location.search,
                                //         true
                                //     );
                                // }, 5000)
                            } else if (
                                updatePasswordReg?.wcipChange?.test(pathname)
                            ) {
                                showErrorPopup(
                                    {
                                        msg: "WCIP_PERFERENCE_001_FAILURE",
                                        code: errorCode,
                                    },
                                    "wcip",
                                    "",
                                    buttonText,
                                    "",
                                    () => {
                                        withLangNavigate(
                                            "/login",
                                            "?NTAL=LDEM",
                                            true
                                        );
                                    }
                                );
                            } else if (
                                updatePasswordReg?.mobileAppChange?.test(
                                    pathname
                                )
                            ) {
                                showErrorPopup(
                                    {
                                        msg: "WCIP_PERFERENCE_001_FAILURE",
                                        code: errorCode,
                                    },
                                    appType,
                                    "",
                                    buttonText,
                                    "",
                                    () => {
                                        window?.ForgotPasswordJSBridge?.closeWebView?.();
                                    }
                                );
                            } else if (
                                updatePasswordReg?.csspChange?.test(pathname)
                            ) {
                                showErrorPopup(
                                    {
                                        msg: "WCIP_PERFERENCE_001_FAILURE",
                                        code: errorCode,
                                    },
                                    "cssp",
                                    "",
                                    buttonText,
                                    "",
                                    () => {
                                        window.location.href = `${window.globalConfig.VITE_CC_URL}/#/profile/password-management`;
                                    }
                                );
                            }
                        } else if (
                            showSystemErrorCodeList.includes(
                                rsp?.payload?.detail?.failureUrl
                            )
                        ) {
                            showErrorPopup(
                                {
                                    msg: "LB_BS_LOGIN_ERROR_CIAM_NETWORK_ERROR_CODE",
                                    code: rsp?.payload?.detail?.failureUrl,
                                },
                                erorType,
                                "",
                                buttonText
                            );
                        }
                    } else {
                        showErrorPopup(
                            {
                                msg: "LB_BS_LOGIN_ERROR_CIAM_NETWORK_ERROR_CODE",
                                code: 401,
                            },
                            erorType,
                            "",
                            buttonText
                        );
                    }
                    return rsp;
                }
                return rsp;
            }
        } catch (error) {
            const buttonText = appType === "HKJCTV" ? "LB_CLOSE" : "LB_OK";
            const appTypeUpperCase = appType?.toUpperCase();
            if (error.message.includes("NetworkError") || error.response) {
                if (isNeedToError) {
                    updatePasswordErrorHandleFunc(withLangNavigate);
                } else if (appType) {
                    console.log("showErrorPopup appTypeUpperCase");
                    showErrorPopup(
                        `LB_BS_LOGIN_ERROR_CIAM_NETWORK_ERROR_${appTypeUpperCase}`,
                        appType,
                        "",
                        buttonText
                    );
                } else {
                    showErrorPopup("LB_BS_LOGIN_ERROR_CIAM_100103");
                }
            } else if (
                (error instanceof TypeError &&
                    error.message === "Failed to fetch") ||
                error.message === "Load failed"
            ) {
                // Handle network connection lost error here
                if (isNeedToError) {
                    updatePasswordErrorHandleFunc(withLangNavigate);
                } else if (appType) {
                    showErrorPopup(
                        `LB_BS_LOGIN_ERROR_CIAM_NETWORK_ERROR_${appTypeUpperCase}`,
                        appType,
                        "",
                        buttonText
                    );
                } else {
                    showErrorPopup("LB_BS_LOGIN_ERROR_CIAM_100103");
                }
            } else if (error?.message?.includes("Timeout")) {
                const message =
                    appType === "HKJCTV"
                        ? "LB_BS_LOGIN_ERROR_CIAM_TIMEOUT_HKJCTV"
                        : "LB_BS_LOGIN_ERROR_CIAM_TIMEOUT";
                showErrorPopup(message, appType || "wcip", "", buttonText);
            } else {
                console.log("Error in next", error);
                const chanelId = getOuthClient();
                if (isNeedToError) {
                    updatePasswordErrorHandleFunc(withLangNavigate);
                } else if (chanelId === "WCIP") {
                    withLangNavigate("/genericerror", "", true);
                    // window.location.href =
                    //     "https://wcip.hkjc.com/genericerrorpage.htm";
                } else {
                    showErrorPopup("LB_BS_LOGIN_ERROR_CIAM_ERROR");
                }
            }
        }
    };
    return {
        next,
    };
};
